import {
  Box,
  Flex,
  Table,
  TableContainer,
  Text,
  Thead,
  Tooltip,
  Tr,
  Image,
} from '@chakra-ui/react';
// import Image from 'next/image';
import { IAssetInPortfolio } from '../types';
import { BigRational } from 'big-rational-ts';
import BigNumber from 'bignumber.js';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { MdSwapHoriz, MdWest } from 'react-icons/md/index.js';
import { assetToUnit, Balance } from '../blockchain/client';
// import ArrowTableSVG from 'src/components/atoms/svg/arrowtable-svg';
import StatusDot from './atoms/svg/statusDot-svg';
import { MeteraTh } from './atoms/table/MeteraTable';
import SwapItem from './swap-item';
import { SettingsModal } from './settings-modal';
import { themeVariables } from '../theme';

const settingsSRC =
  'https://sqvzfgobtlzbovqbkaax.supabase.co/storage/v1/object/public/sdk-assets//settings.svg';
const cardanoSrc =
  'https://sqvzfgobtlzbovqbkaax.supabase.co/storage/v1/object/public/sdk-assets//cardanoimage.png';
const minswapSrc =
  'https://sqvzfgobtlzbovqbkaax.supabase.co/storage/v1/object/public/sdk-assets//minswap_horizontal.svg';

type SwapBreakdownProps = {
  type: 'mint' | 'burn';
  portfolioAssets: IAssetInPortfolio[];
  balance: Balance | null;
  amountsToModify: Record<string, bigint>;
  formattedState: {
    prices: Record<string, BigRational>;
    weights: Record<string, BigRational>;
    state: {
      assets: Record<string, bigint>;
      mtkSupply: bigint;
    };
  };
  hideBreakdown: () => void;
  isModal?: boolean;
  swapDeficit: boolean;
  setSwapDeficit: Dispatch<SetStateAction<boolean>>;
  background?: string;
};

const SwapBreakdown: React.FC<SwapBreakdownProps> = ({
  type,
  portfolioAssets,
  balance,
  amountsToModify,
  formattedState,
  hideBreakdown,
  isModal = true,
  setSwapDeficit,
  swapDeficit,
  background,
}) => {
  const [settingsModal, setSettingsModal] = useState(false);
  const handleSettingsModal = () => {
    setSettingsModal(true);
  };
  return (
    <Flex
      width={'full'}
      height={'full'}
      flexDirection={'column'}
      padding="1rem"
      background={background ? background : themeVariables.background.modal}
    >
      <Flex width={'100%'} flexDirection={'column'} gap={1} padding={'8px'}>
        <Flex justify="space-between">
          <Flex
            as="button"
            onClick={hideBreakdown}
            justify="left"
            gap={2}
            align="center"
          >
            <MdWest
              fontSize="1.5rem"
              color="#a78bfa"
              onClick={hideBreakdown}
              cursor="pointer"
            />
            <Box fontSize="0.75rem" color="var(--off-white)">
              Go back
            </Box>
          </Flex>
          <Box
            as="button"
            onClick={handleSettingsModal}
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="50%"
            bg="var(--bg-200)"
            _hover={{
              transform: 'scale(1.1)',
            }}
            p={2}
          >
            <Image
              src={settingsSRC}
              objectFit="contain"
              alt="settings"
              display="block"
            />
          </Box>

          <SettingsModal
            children={undefined}
            isOpen={settingsModal}
            onClose={() => setSettingsModal(false)}
            controls={{
              SWAP_DEFICIT: {
                value: swapDeficit,
                setValue: setSwapDeficit,
              },
            }}
          />
        </Flex>
        <Flex
          width={'100%'}
          justifyContent={'left'}
          gap={'1rem'}
          align="center"
        >
          <Box
            width="2rem"
            height="2rem"
            overflow="hidden"
            borderRadius="50%"
            position="relative"
          >
            <Image src={cardanoSrc} alt="ADA" />
          </Box>
          <MdSwapHoriz fontSize="2rem" color="var(--neutral-400)" />
          <Flex align="center">
            {portfolioAssets
              .sort((a, b) => a.asset.ticker.localeCompare(b.asset.ticker))
              .slice(0, 3)
              .map((assetInPortfolio, i) => (
                <Box
                  key={assetInPortfolio.asset.id + i}
                  width="2rem"
                  height="2rem"
                  overflow="hidden"
                  borderRadius="50%"
                  ml="-0.5rem"
                  zIndex={3 + i}
                  position="relative"
                >
                  <Image
                    key={assetInPortfolio.asset.id + i}
                    src={assetInPortfolio.asset.imageUrl}
                    alt={assetInPortfolio.asset.ticker}
                  />
                </Box>
              ))}
            {portfolioAssets.length > 3 && (
              <Box
                fontSize="0.725rem"
                alignItems="center"
                justifyContent="center"
                color="var(--off-white-400)"
                background="var(--purple-button-100)"
                width="28px"
                height="28px"
                borderRadius="full"
                padding="0.3rem"
                marginLeft="-1rem"
                zIndex={10}
              >
                <Flex
                  align="center"
                  height="full"
                  justify="center"
                  fontWeight={700}
                >
                  +{portfolioAssets.length - 3}
                </Flex>
              </Box>
            )}
          </Flex>
          <Box color="var(--neutral-400)" fontSize="0.875rem">
            via
          </Box>
          <Box width="7rem" overflow="hidden" position="relative">
            <Image src={minswapSrc} alt="minswap" />
          </Box>
        </Flex>
      </Flex>
      {/* <Flex justify="center">
      <SwapDeficitSwitch
        setSwapDeficit={setSwapDeficit}
        swapDeficit={swapDeficit}
        fontSize="0.875rem"
      />
    </Flex> */}
      <Box
        overflowY="auto"
        background="var(--table-modals)"
        borderRadius={'0.75rem'}
        width="full"
        height="full"
        paddingTop={'0.15rem'}
      >
        <Flex gap={3} overflow="auto">
          <TableContainer
            overflowY="auto"
            sx={{
              '&::-webkit-scrollbar': {
                width: '0px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'none',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: 'none',
              },
            }}
          >
            <Table
              variant="unstyled"
              sx={{
                tableLayout: 'fixed',
              }}
            >
              <Thead
                position={'sticky'}
                top={0}
                left={0}
                zIndex={1}
                borderBottom="none"
              >
                <Tr>
                  <MeteraTh
                    textAlign="left"
                    paddingX={'8px'}
                    paddingY="1rem"
                    paddingLeft={'10px'}
                    fontSize="0.875rem"
                    color="var(--neutral-400)"
                    borderTopLeftRadius="full"
                  >
                    Token
                  </MeteraTh>
                  <MeteraTh
                    paddingX={0}
                    paddingY="1rem"
                    fontSize="0.875rem"
                    color="var(--neutral-400)"
                  >
                    {type === 'mint' ? (
                      <Flex width="full" justify="left" gap={2}>
                        <Box>You Deposit</Box>
                      </Flex>
                    ) : (
                      <Flex width="full" justify="left" gap={2}>
                        <Box>You Withdraw</Box>
                      </Flex>
                    )}
                  </MeteraTh>
                  <MeteraTh
                    textAlign="center"
                    paddingX={'8px'}
                    paddingY="1rem"
                    paddingLeft={'10px'}
                    fontSize="0.875rem"
                    color="var(--neutral-400)"
                  >
                    Your Balance
                  </MeteraTh>
                  <MeteraTh
                    textAlign="center"
                    paddingX={0}
                    paddingY="1rem"
                    fontSize="0.875rem"
                    color="var(--neutral-400)"
                    paddingRight={'6px'}
                  >
                    You Swap
                  </MeteraTh>
                </Tr>
              </Thead>
              <tbody style={{ maxHeight: '286px' }}>
                {portfolioAssets
                  .sort((a, b) => a.asset.ticker.localeCompare(b.asset.ticker))
                  .map((assetInPortfolio, i) => (
                    <SwapItem
                      item={assetInPortfolio}
                      key={assetInPortfolio.asset.id + i}
                      type={type}
                      balance={balance}
                      amountsToModify={amountsToModify}
                      formattedState={formattedState}
                      swapDeficit={swapDeficit}
                    />
                  ))}
              </tbody>
            </Table>
          </TableContainer>
        </Flex>
      </Box>
    </Flex>
  );
};

export function SwapBreakdownButton(props: SwapBreakdownProps) {
  const { portfolioAssets, balance, amountsToModify } = props;
  const [showBreakdown, setShowBreakdown] = useState<boolean>(false);

  const hasAllTokens = portfolioAssets.every((item) =>
    BigNumber((amountsToModify[item.asset.id] || 0n).toString()).lte(
      BigNumber((balance?.[assetToUnit(item.asset)] || 0n).toString()),
    ),
  );

  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'center'}
      gap={'1rem'}
    >
      <Flex
        paddingX="0.5rem"
        background="var(--table-modals)"
        border="1px solid var(--cards-stroke)"
        borderRadius="62rem"
        gap={2}
        width="230px"
        height="2.5rem"
        cursor={'pointer'}
        onClick={() => setShowBreakdown(!showBreakdown)}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <StatusDot
          showStatus={false}
          status={hasAllTokens ? 'Confirmed' : 'Insufficient'}
        />
        <Text
          fontSize="14px"
          fontWeight="400"
          lineHeight="20px"
          textAlign="left"
        >
          {showBreakdown ? 'Hide' : 'View'} token breakdown
        </Text>

        <Box>
          {showBreakdown ? (
            <Box transform="rotate(-90deg)" marginTop="2px">
              {/* <ArrowTableSVG /> */}
            </Box>
          ) : (
            <Box transform="rotate(90deg)" marginTop="4px">
              {/* <ArrowTableSVG /> */}
            </Box>
          )}
        </Box>
      </Flex>
      {/* {!hasAllTokens && (
        <Text
          fontSize="14px"
          fontWeight="400"
          lineHeight="20px"
          textAlign="left"
          color={'#FBBF24'}
        >
          Assets not found in wallet. Basket buy required.
        </Text>
      )} */}

      <SwapBreakdown {...props} />
    </Flex>
  );
}

export default SwapBreakdown;
